<template>
	<div class="layout-topbar">
		<router-link to="/" class="layout-topbar-logo">
			<img alt="Logo" :src="topbarImage()" />
			<span>HeySens</span>
		</router-link>
		<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
			<i class="pi pi-bars"></i>
		</button>

		<button class="p-link layout-topbar-menu-button layout-topbar-button" v-styleclass="{
			selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein',
			leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true
		}">
			<i class="pi pi-ellipsis-v"></i>
		</button>
		<ul class="layout-topbar-menu hidden lg:flex origin-top align-items-center">
			<li>
				<button
					class="p-link layout-topbar-button topbar-locale-button"
					type="button"
					:aria-label="$t('topbar.language')"
					aria-haspopup="true"
					:aria-expanded="isLocaleMenuOpen ? 'true' : 'false'"
					aria-controls="topbar-locale-menu"
					@click="toggleLocaleMenu"
				>
					<i class="pi pi-globe"></i>
					<span>{{ currentLocaleLabel }}</span>
				</button>
				<Menu
					id="topbar-locale-menu"
					ref="localeMenu"
					:model="localeMenuItems"
					:popup="true"
					@show="onLocaleMenuShow"
					@hide="onLocaleMenuHide"
				/>
			</li>
			<li>
				<span>{{ userName }}</span>
			</li>
			<li>
				<button class="p-link layout-topbar-button" @click="logout">
					<i class="pi pi-sign-out"></i>
					<span>{{ $t('topbar.settings') }}</span>
				</button>
			</li>
		</ul>
		<ConfirmPopup></ConfirmPopup>
	</div>
</template>

<script>
import { removeToken } from '@/utils/auth'
import { getSavedLocale, saveLocale } from '@/utils/locale'

	export default {
	data() {
		return {
			userName: null,
			selectedLocale: this.$appState.locale,
			isLocaleMenuOpen: false,
		}
	},
	mounted() {
		this.localUserInfo = JSON.parse(window.localStorage.getItem('userinfo'));
		this.userName = this.localUserInfo.username;
    },
	watch: {
		'$appState.locale'(locale) {
			this.selectedLocale = locale;
		}
	},
	methods: {
		clearLogoutStorage() {
			const savedLocale = getSavedLocale();

			window.localStorage.clear();

			if (savedLocale) {
				saveLocale(savedLocale);
			}
		},
		onMenuToggle(event) {
			this.$emit('menu-toggle', event);
		},
		toggleLocaleMenu(event) {
			this.$refs.localeMenu.toggle(event);
		},
		onLocaleMenuShow() {
			this.isLocaleMenuOpen = true;
		},
		onLocaleMenuHide() {
			this.isLocaleMenuOpen = false;
		},
		onTopbarMenuToggle(event) {
			this.$emit('topbar-menu-toggle', event);
		},
		topbarImage() {
			return this.$appState.darkTheme ? '/images/heysens-logo.svg' : '/images/heysens-logo.svg';
		},
		handleLocaleChange(event) {
			const locale = event && event.value ? event.value : this.selectedLocale;
			this.isLocaleMenuOpen = false;
			this.selectedLocale = this.$setLocale(locale);
		},
		logout() {
			const localUserInfo = window.localStorage.getItem('userinfo');
			const userInfo = localUserInfo ? JSON.parse(localUserInfo) : null;
			removeToken();
			this.clearLogoutStorage();
			location.reload()
			this.$http('/api/admin/login/exit', {
				user: userInfo ? userInfo.phone : undefined
			}).then((res) => {
				if (res.code == 200) {
					removeToken()
					this.clearLogoutStorage();
					location.reload()
				}
			})
			.catch((err) => { console.log(err) });
		}
	},
	computed: {
		darkTheme() {
			return this.$appState.darkTheme;
		},
		currentLocaleLabel() {
			const selectedOption = this.localeOptions.find((option) => option.value === this.selectedLocale);
			return selectedOption ? selectedOption.label : '';
		},
		localeOptions() {
			return [
				{ label: this.$t('locale.zh'), value: 'zh' },
				{ label: this.$t('locale.vi'), value: 'vi' }
			];
		},
		localeMenuItems() {
			return this.localeOptions.map((option) => ({
				label: option.label,
				command: () => this.handleLocaleChange({ value: option.value })
			}));
		}
	}
}
</script>

<style scoped>
.topbar-locale-button {
	border-radius: 12px;
	width: auto;
	padding: 0 1rem;
	gap: 0.5rem;
}

.topbar-locale-button span {
	display: block;
}

.sr-only {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
}
</style>
